import React from 'react';
import './Features.css';
import { FaBrain, FaMobile, FaLock, FaChartBar, FaHeadset, FaSync } from 'react-icons/fa';

const Features = () => {
  const features = [
    {
      icon: <FaBrain />,
      title: 'AI-Enabled Features',
      description: 'Leverage artificial intelligence for predictive analytics, automated workflows, and intelligent decision support'
    },
    {
      icon: <FaMobile />,
      title: 'Mobile Responsive',
      description: 'Fully optimized for mobile devices, tablets, and desktops'
    },
    {
      icon: <FaLock />,
      title: 'Data Security',
      description: 'Enterprise-grade encryption and compliance with healthcare standards'
    },
    {
      icon: <FaChartBar />,
      title: 'Advanced Analytics',
      description: 'Real-time insights and comprehensive reporting for informed decisions'
    },
    {
      icon: <FaHeadset />,
      title: '24/7 Support',
      description: 'Round-the-clock technical support from our expert team'
    },
    {
      icon: <FaSync />,
      title: 'Easy Integration',
      description: 'Seamless integration with existing systems and third-party applications'
    }
  ];

  return (
    <section id="features" className="features section">
      <div className="container">
        <h2 className="section-title">Why Choose <span className="gradient-text">Grandis Solutions</span></h2>
        <p className="section-subtitle">
          Our healthcare software solutions are built with cutting-edge technology to deliver 
          reliability, security, and exceptional performance
        </p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-item" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="feature-icon-wrapper">
                <div className="feature-icon">{feature.icon}</div>
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="features-cta">
          <h3>Ready to Transform Your Healthcare Operations?</h3>
          <p>Join hundreds of healthcare facilities already benefiting from our solutions</p>
          <button className="btn-primary" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
            Schedule a Demo
          </button>
        </div>
      </div>
    </section>
  );
};

export default Features;
